module.exports = __webpack_public_path__ + "static/studio-06-9973696b242f02309596269919ec1307.png";